import { render } from "./Carousel.vue?vue&type=template&id=5c34f3d2&scoped=true"
const script = {}

import "./Carousel.vue?vue&type=style&index=0&id=5c34f3d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c34f3d2"]])

export default __exports__